import './style.scss';
import Chart from 'chart.js/auto';


const chartElements = document.querySelectorAll('.atcb-pie-chart__canvas');

if (chartElements && chartElements.length !== 0) {
    chartElements.forEach(ctx => {

        const nextElem = ctx.nextElementSibling;

        const children = nextElem.querySelectorAll('.atcb-pie-chart__data-item');

        if (!children || children.length === 0) return;

        const dataList = [];
        const colorList = [];

        children.forEach(item => {
            const color = item.dataset.color;
            const number = item.dataset.number;

            dataList.push(number);
            colorList.push(color);
        });

        const data = {
            datasets: [{
                data: dataList,
                backgroundColor: colorList,
                borderWidth: 4,
            }]
        };
        

        new Chart(ctx, {
            type: 'pie',
            data: data,
            options: {
                animation: false,
                plugins: {
                    tooltip: {
                        enabled: false,
                    }
                }
            }
        });
    });
}



